import { useParams } from '@gogame/screens';
import { useSocket } from '@gogame/sockets';

import { EVENT_MP_BLUR } from '../constants';

export const useSocketBlurEmitter = ({ path }) => {
  const socket = useSocket();
  const params = useParams();
  return () => {
    socket.emit(EVENT_MP_BLUR, {
      year: params.year,
      month: params.month,
      version: params.version,
      path,
    });
  };
};
